import { render, staticRenderFns } from "./PlanejamentoAcaoModalNovaAcaoPasso2.vue?vue&type=template&id=68b18c06"
import script from "./PlanejamentoAcaoModalNovaAcaoPasso2.vue?vue&type=script&lang=js"
export * from "./PlanejamentoAcaoModalNovaAcaoPasso2.vue?vue&type=script&lang=js"
import style0 from "./PlanejamentoAcaoModalNovaAcaoPasso2.vue?vue&type=style&index=0&id=68b18c06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports